import api from './../../api/api'




export default {
  upload: async (url, file, onProgress, id, cancelToken) => {    

    let formData = new FormData()
    formData.append('file', file)
    return api.post(url, formData, {
      cancelToken: cancelToken,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: progressEvent => {
        onProgress(parseInt(
          Math.round((progressEvent.loaded / progressEvent.total) * 85)
        ), id)
      }
    })
  },

  cancel:(source) =>{
    source.cancel('Operation canceled by the user.');
  }

}
